import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { toast } from 'react-toastify';

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const access_token = searchParams.get('access_token');
  const user_id = searchParams.get('user_id');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (access_token && user_id) {
      login(user_id, access_token, true); // Remember me true for google sign in
      toast.success('Login Successful!');
      navigate('/chat');
    } else {
      toast.error('Failed to log in with Google.');
      navigate('/login');
    }
  }, [access_token, user_id, login, navigate]);

  return <div>Loading...</div>;
};

export default GoogleCallback;